<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<a id="page03">
<h2 class="partNumber"><span class="bold">I</span></h2>
<div class="partEpigraph">
<p class="partEpigraphText">Behold! Exalted, I nave come. I have escaped from the nether world. The roads of the earth and of the sky are open before me.</p>
<p class="partEpigraphSource">The Book of the Dead, 78</p></div></a></div><a id="page03">
<div class="partBody">
</div>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_pt01.vue?567ed90c